export default "__VITE_ASSET__2ce8fe41__"